export default __webpack_public_path__ + "static/media/LU-logo-EN.f0d55afb.png";